/**
 * Build/host-level feature switches.
 *
 * Kept separate from theme/brand.js: that module answers "how does this deployment LOOK",
 * this one answers "what does this deployment EXPOSE".
 *
 * IMPORTANT (Create React App): env vars are inlined at BUILD time and must be read as a
 * literal `process.env.REACT_APP_*` member expression — a dynamic lookup silently breaks
 * the substitution.
 */

/** Matches xnotifydemo.com and any subdomain of it (demo.xnotifydemo.com, …). */
const DEMO_HOST = /(^|\.)xnotifydemo\.com$/i;

function isDemoHost() {
  if (typeof window === 'undefined' || !window.location) return false;
  return DEMO_HOST.test(window.location.hostname || '');
}

/**
 * Tri-state env read: `null` when the var is absent or blank so the caller can apply its
 * own default, otherwise the parsed boolean. "false"/"0"/"no"/"off" are all falsey, since
 * a plain `Boolean("false")` is `true` and that mistake is easy to make in a .env.
 */
function envFlag(value) {
  const text = String(value == null ? '' : value).trim().toLowerCase();
  if (!text) return null;
  return !['false', '0', 'no', 'off'].includes(text);
}

/**
 * AI Insights (FEAT-0012 — the Campaign Report tab that runs the Campaign Performance
 * Analyst) must not be exposed on the public demo.
 *
 * `REACT_APP_ENABLE_AI_INSIGHTS=true|false` is the explicit control. Left unset it
 * defaults to ON everywhere EXCEPT the demo host, so demo.xnotifydemo.com hides the tab
 * with no .env change of its own, and every other deployment is unaffected.
 */
export const AI_INSIGHTS_ENABLED =
  envFlag(process.env.REACT_APP_ENABLE_AI_INSIGHTS) ?? !isDemoHost();

const featureFlags = { AI_INSIGHTS_ENABLED };

export default featureFlags;
